const { dayjs } = window.sfp.scriptLibs;

export const crmFormElementNameByElementId = function (id) {
  return `tx_htwevents_eventform[htwCrmForm][${id}]`;
};

export const getSelectedWorkshops = function (value, workshops) {
  let selectedWorkshops = [];
  Object.keys(value).forEach(function (id) {
    const selectData = value[id];

    if (!selectData) {
      return;
    }
    selectedWorkshops.push({
      selectData: selectData,
      workshop: workshops[id],
    });
  });

  return selectedWorkshops;
};

export const getFormattedDateLabel = function (startDate, endDate) {
  const startDay = dayjs(startDate).format('DD.MM.YYYY');
  const endDay = dayjs(endDate).format('DD.MM.YYYY');
  let dateLabel;
  if (startDay === endDay) {
    dateLabel = dayjs(startDate).format('dddd D. MMMM YYYY');
  } else {
    dateLabel =
      dayjs(startDate).format('dddd D. MMMM') +
      ' - ' +
      dayjs(endDate).format('D. MMMM YYYY');
  }

  return dateLabel;
};

export const getFormattedTimeLabel = function (startDate, endDate) {
  return (
    dayjs(startDate).format('HH:mm') + ' - ' + dayjs(endDate).format('HH:mm')
  );
};
